export default () => {
	(function ($) {
		if ($('.section--video-player').length) {
			$(document).ready(function () {
				var ctrlVideo = document.getElementById('player');
				var $wrapper = $('.video-player');
				var $button = $('.video-player__btn');

				$button.on('click', function (e) {
					e.preventDefault();

					if (!$button.hasClass('active')) {
						ctrlVideo.play();
						$wrapper.toggleClass('playing');
					} else {
						ctrlVideo.pause();
						$wrapper.toggleClass('playing');
					}
				});
			});
		}
	})(jQuery);
}
